
interface LoadingScreenProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  showMessage?: boolean;
}

export function LoadingScreen({ 
  message = "Caricamento...", 
  size = 'md',
  showMessage = false 
}: LoadingScreenProps) {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8', 
    lg: 'h-10 w-10'
  };

  return (
    <div className="min-h-screen tg-bg flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div className={`animate-spin rounded-full border-b-2 border-blue-500 ${sizeClasses[size]}`} />
        {showMessage && (
          <p className="text-sm text-white/60 animate-pulse">{message}</p>
        )}
      </div>
    </div>
  );
}
